module.exports = __webpack_public_path__ + "img/51_30.9812abc1.png";